import { apiClient } from './apiClient';

const getPublicStreamers = async () => apiClient.get('/public/streamers');
const getAdminPublicStreamers = async () => apiClient.get('/dashboard/public-streamers');
const syncPublicStreamers = async () => apiClient.post('/dashboard/public-streamers/sync');

export const publicStreamerApi = {
  getPublicStreamers,
  getAdminPublicStreamers,
  syncPublicStreamers
};
